"use client";

import { Input } from "@headlessui/react";
import { debounce } from "lodash";
import { useCallback, useState } from "react";
import {
  fetchDataAlleGebruikersFilter,
} from "../apiCalls/usersApi";
import Pagination from "./Pagination";
import TabsFilter from "./TabsFilter";

const SelectGebruikers = ({
  selected,
  setSelected,
  page,
  setPage,
  pageSize,
  setPageSize,
  desiredColumns,
  setType,
  setRole,
  role,
  type,
  data,
  setData,
  setLoading,
  setError,
  activeTab,
  setActiveTab,
}) => {
  const [search, setSearch] = useState("");

  // Add debounced search function
  const selectTab = useCallback((role, type) => {
    setType(type);
    setRole(role);
  }, []);

  const debouncedSearch = useCallback(
    debounce((searchQuery) => {
      
      fetchDataAlleGebruikersFilter(
        page,
        pageSize,
        setLoading,
        setError,
        setData,
        desiredColumns,
        role,
        type,
        searchQuery
      );
    }, 300),
    []
  );

  const tabs = [
    {
      id: 1,
      name: "Alle gebruikers",
      onClick: () => {
        selectTab(null, "all");
        setActiveTab("Alle gebruikers");
      },
    },
    {
      id: 2,
      name: "Specialisten",
      onClick: () => {
        selectTab(1, "role");
        setActiveTab("Specialisten");
      },
    },
    {
      id: 3,
      name: "Patienten",
      onClick: () => {
        selectTab(2, "role");
        setActiveTab("Patienten");
      },
    },
    {
      id: 4,
      name: "Niet Ingeschreven",
      onClick: () => {
        selectTab(999, "role");
        setActiveTab("Niet Ingeschreven");
      },
    },
  ];

  // Add debounced search function

  return (
    <div className="border-b border-wa-border bg-wa-app">
      <div className="m-0 flex flex-col gap-3 px-3 py-3 sm:px-4">
        <TabsFilter data={tabs} activeTab={activeTab} variant="wa" />
        <div className="flex min-w-0 flex-col gap-2 lg:flex-row lg:items-stretch lg:gap-3">
          <div className="min-w-0 flex-1">
            <Input
              placeholder="Zoeken"
              className="block w-full rounded-lg border border-wa-border bg-wa-panel py-2.5 pl-3 pr-3 text-sm text-wa-text outline-none ring-0 placeholder:text-wa-muted focus:border-wa-accent focus:ring-1 focus:ring-wa-accent sm:text-sm/6"
              onChange={(event) => {
                setSearch(event.target.value);
                debouncedSearch(event.target.value);
              }}
              displayValue={(person) =>
                person?.full_name ||
                person?.email ||
                person?.first_name ||
                person?.last_name ||
                person?.firstname ||
                person?.lastname
              }
            />
          </div>
          <div className="w-full flex-shrink-0 lg:w-[min(100%,320px)] lg:max-w-sm">
            <Pagination
              variant="compact"
              page={page}
              setPage={setPage}
              pageSize={pageSize}
              setPageSize={setPageSize}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectGebruikers;
